import React from 'react';
import UseCreateAQrCodeStore from './CreateAQrCodeStore';
import CreateAQrCode from './CreateAQrCode';

const CreateAQrCodeContainer = ({ ...props }) => <UseCreateAQrCodeStore.Provider><CreateAQrCode {...props} /></UseCreateAQrCodeStore.Provider>;

export default CreateAQrCodeContainer;
